import { Fragment, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import Breadcrumbs from "../../components/Breadcrumbs";
import ProjectInformation from "../../components/ProjectInformation";
import { Col, Row } from "antd";
import Title from "../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import DashboardPages from "../../Dashboard/DashboardPages";
import Tables from "../../components/Tables";
import {
  TYPE_CHECK_DASHBOARD,
  tableBetelDailyRevenue,
  TYPE_GET_DATE,
} from "../../../helper/const";
import DailyRevenueChart from "../../components/DailyRevenueChart";
import RevenueOfChannelChart from "../../components/RevenueOfChannelChart";
import { getDataRevenueBitel } from "../../../redux/Future/Bitel/action";
import { useSelector } from "react-redux";
import { selectorDataBitel } from "../../../redux/selector";
import { useDispatch } from "react-redux";
import {
  formatDataDailyRevenueChart,
  formatDataQuantityRevenue,
  formatDataStatisticTable,
  getDateChangeTime,
} from "../../../helper/helper";
import FilterTime from "../../components/FilterTime";
import { apiRevenueBitel } from "../../../api/ApitBitel";
import { idProject } from "../../../helper/const";
import { formatDataNumberToen } from "../../../helper/helper";
import styled from "styled-components";

export default function BitelRevenue() {
  const dispatch = useDispatch();
  let dataDailyRevenueChart = [];

  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  useEffect(() => {
    dispatch(getDataRevenueBitel(apiRevenueBitel(startDate, endDate)));
  }, [startDate, endDate]);

  const { revenue = {} } = useSelector(selectorDataBitel);

  let quantityRevenue = {
    data: [],
    xField: "time",
    yField: ["totalRevenue", "quantity"],

    annotations: {
      quantity: [],
    },
  };
  let revenueOfChannel = {
    data: [],
    xField: "type",
    yField: ["revenue"],
  };

  let columnsBitelRevenue = { dataKey: [], defineData: [] };

  useMemo(() => {
    const { dataDetail = [], dataOverview = [] } = revenue.result || {};
    quantityRevenue = formatDataQuantityRevenue(
      dataOverview,
      TYPE_CHECK_DASHBOARD.overview
    );

    revenueOfChannel = formatDataQuantityRevenue(
      dataOverview,
      TYPE_CHECK_DASHBOARD.revenue
    );
    columnsBitelRevenue = formatDataStatisticTable(dataOverview);

    dataDailyRevenueChart = formatDataDailyRevenueChart(dataDetail);

    //Daily Revenue Table
    const formatDataApi = dataDetail.map((item = {}) => {
      const { chargeTime = 0, packs, value = 0 } = item;
      const defineDataDailyRevenueTable = {
        SUBASTA_DAILY: 0,
        SUBASTA_WEEKLY: 0,
        SUBASTA_MONTHLY: 0,
        CHANCE: 0,
        CHANCE2: 0,
        CHANCE5: 0,
        CHANCE10: 0,
      };
      packs.forEach((packItem = {}) => {
        const idPack = packItem.id;
        defineDataDailyRevenueTable[idPack] = packItem.amount;
      });
      return {
        Chargetime: chargeTime,
        Day: defineDataDailyRevenueTable.SUBASTA_DAILY,
        Week: defineDataDailyRevenueTable.SUBASTA_WEEKLY,
        Month: defineDataDailyRevenueTable.SUBASTA_MONTHLY,
        CHANCE: defineDataDailyRevenueTable.CHANCE,
        CHANCE2: defineDataDailyRevenueTable.CHANCE2,
        CHANCE5: defineDataDailyRevenueTable.CHANCE5,
        CHANCE10: defineDataDailyRevenueTable.CHANCE10,
        Dayrevenue: value,
      };
    });
    let total = {
      CHANCE: 0,
      CHANCE2: 0,
      CHANCE5: 0,
      CHANCE10: 0,
      Chargetime: "Total",
      Day: 0,
      Dayrevenue: 0,
      Month: 0,
      Week: 0,
    };

    formatDataApi.forEach((item) => {
      total.Day += item.Day || 0;
      total.Week += item.Week || 0;
      total.Month += item.Month || 0;
      total.CHANCE += item.CHANCE || 0;
      total.CHANCE2 += item.CHANCE2 || 0;
      total.CHANCE5 += item.CHANCE5 || 0;
      total.CHANCE10 += item.CHANCE10 || 0;
      total.Dayrevenue += item.Dayrevenue || 0;
    });

    for (const key in total) {
      if (typeof total[key] === "number") {
        total[key] = formatDataNumberToen(parseFloat(total[key]));
      }
    }

    const convertDataNumber = formatDataApi.map((item) => {
      return {
        ...item,
        CHANCE: formatDataNumberToen(item.CHANCE),
        CHANCE2: formatDataNumberToen(item.CHANCE2),
        CHANCE5: formatDataNumberToen(item.CHANCE5),
        CHANCE10: formatDataNumberToen(item.CHANCE10),
        Day: formatDataNumberToen(item.Day),
        Dayrevenue: formatDataNumberToen(item.Dayrevenue),
        Month: formatDataNumberToen(item.Month),
        Week: formatDataNumberToen(item.Week),
      };
    });

    tableBetelDailyRevenue.defineData = [total, ...convertDataNumber].reverse();
  }, [revenue.result]);

  return (
    <Container>
      <Breadcrumbs data={["Bitel", "Subasta"]} />
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
        <Row className="panel panel-sortable">
          <Title titleName="Overview" startDate={startDate} endDate={endDate}>
            <BranchesOutlined />
          </Title>
          <Col span={24}>
            <Row>
              <Col xs={24} lg={12} className="container-item">
                <h4 className="pt-3 pe-3 pb-5">
                  Overview Quantity - Revenue chart:
                </h4>
                <div className="item-chart">
                  <DashboardPages dataDashboard={quantityRevenue} />
                </div>
              </Col>
              <Col xs={24} lg={12} className="container-item">
                <h4 className="pt-3 pe-3 pb-5">Revenue of channel chart:</h4>
                <div className="item-chart">
                  <RevenueOfChannelChart dataChart={revenueOfChannel} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div id="table-bitel">
        <Tables
          columns={columnsBitelRevenue}
          isHiddenPagination={false}
          title="Overview statistic table"
        />
      </div>
      <div className="container-dashboard">
        <Row className="panel panel-sortable">
          <Title
            titleName="Daily Revenue Chart"
            startDate={startDate}
            endDate={endDate}
          >
            <BranchesOutlined />
          </Title>
          <div className="container-daily">
            <div className="dailyRevenueChart">
              <DailyRevenueChart dataRevenueChart={dataDailyRevenueChart} />
            </div>
          </div>
        </Row>
      </div>
      <Tables columns={tableBetelDailyRevenue} title="Daily Revenue Table" />
      <ProjectInformation id={idProject.bitel} />
    </Container>
  );
}

const Container = styled.div`
  @media (max-width: 576px) {
    h4 {
      padding-bottom: 0px !important;
    }
  }

  @media (max-width: 768px) {
    .container-daily {
      max-width: 100%;
      overflow: auto;
    }

    .dailyRevenueChart {
      min-width: 800px;
      overflow-x: auto;
    }
  }
`;
